<!--
 * @Author: Merlin
 * @Date: 2024-03-11 09:59:25
 * @LastEditors: Merlin
 * @LastEditTime: 2024-07-15 13:25:02
 * @Description: 这是大表格的单元格容器 
-->

<template>
    <div class="flex pr-3 flex-1 items-center" >
        <slot />
    </div>
</template>

<script lang="ts" setup>

// const props = defineProps({
//     xxx: Number,
// });


</script>
